import { fetchHideRating, THideRatingResponse } from '../../repositories/cian-chat-bot/v1/hide-rating';
import { IApplicationContext } from '../../types/applicationContext';

const DEGRADATION_TELEMETRY_KEY = 'degradation.chatbotHideRating';
export async function fetchCloseRating({ httpApi, logger, telemetry }: IApplicationContext): Promise<void> {
  try {
    const { response, statusCode }: THideRatingResponse = await fetchHideRating({
      httpApi,
    });

    if (statusCode !== 200) {
      telemetry.increment(DEGRADATION_TELEMETRY_KEY);
      logger.warning('Невалидный ответ от сервера', {
        domain: 'src/shared/services/chatbotFeedback/fetchCloseRating/fetchCloseRating.ts',
        statusCode,
        message: response.message || 'Неизвестная ошибка',
        errors: JSON.stringify(response?.errors),
      });
    }
  } catch (error) {
    telemetry.increment(DEGRADATION_TELEMETRY_KEY);
    logger.error(error, {
      domain: 'src/shared/services/chatbotFeedback/fetchCloseRating/fetchCloseRating.ts',
      message: 'Не удалось отправить событие закрытия окна с оценкой',
    });
  }
}
